export default {
  "FoodOpC_Notifications_Full_time_tbyY": "全時間帯使用可",
  "FoodOpC_Notifications_No_order_CPhU": "最低注文金額の条件なし",
  "FoodOpC_Notifications_All_stores_lcyT": "全店舗使用可",
  "FoodOpC_Notifications_All_payments_ERiC": "全ての支払方法で使用可",
  "FoodOpC_Notifications_Full_service_HBkd": "全てのサービス提供都市で使用可",
  "FoodOpC_Notifications_Some_stores_BdsO": "一部店舗使用可",
  "coupon": {
    "other": {
      "time": "有効期限： {name} ",
      "hide": "非表示",
      "cost": "{name} より割引",
      "min": " {name} 以上で適用",
      "show": "詳細を見る",
      "cardBin": "カードビンが {name} の場合にのみ使用できます",
      "limit": "{name} に限り利用可",
      "new": "新規のお客様に限り利用可",
      "max": "割引上限 {name} ",
      "off": "OFF",
      "limitUse": "{name} に限り利用可",
      "use": "割引対象： {name} "
    },
    "costType": {
      "order": "合計金額",
      "delivery": "配達料金",
      "meals": "商品合計金額"
    },
    "useRuleWeekDay": {
      "Monday": "月曜日",
      "Thursday": "木曜日",
      "Saturday": "土曜日",
      "Tuesday": "火曜日",
      "Sunday": "日曜日",
      "Friday": "金曜日",
      "Wednesday": "水曜日"
    },
    "payTypeList": {
      "all": "全ての支払方法",
      "card": "カード",
      "pay": "99Pay-残高",
      "pos": "決済機",
      "money": "現金"
    }
  }
}